// Funcionalidad de Tooltips para Breadcrumbs
class BreadcrumbTooltips {
  constructor() {
    this.init();
  }

  init() {
    // Remover tooltips existentes al cargar
    this.removeAllTooltips();
    
    // Agregar event listeners
    this.addEventListeners();
    
    // Manejar redimensionamiento de ventana
    window.addEventListener('resize', () => {
      this.removeAllTooltips();
    });
    
    // Inicializar manejo de dropdowns
    this.initDropdownHandlers();
  }

  initDropdownHandlers() {
    // Manejar eventos de apertura/cierre de dropdowns
    document.addEventListener('show.bs.dropdown', (event) => {
      const dropdownMenu = event.target.nextElementSibling;
      if (dropdownMenu && dropdownMenu.classList.contains('dropdown-menu')) {
        // Forzar z-index alto y posición fija
        dropdownMenu.style.zIndex = '999999';
        dropdownMenu.style.position = 'fixed';
        
        // Asegurar que esté visible
        setTimeout(() => {
          dropdownMenu.style.zIndex = '999999';
          dropdownMenu.style.position = 'fixed';
        }, 10);
      }
    });
    
    document.addEventListener('shown.bs.dropdown', (event) => {
      const dropdownMenu = event.target.nextElementSibling;
      if (dropdownMenu && dropdownMenu.classList.contains('dropdown-menu')) {
        // Doble verificación después de que se muestre
        dropdownMenu.style.zIndex = '999999';
        dropdownMenu.style.position = 'fixed';
      }
    });
  }

  addEventListeners() {
    const tooltipElements = document.querySelectorAll('[data-tooltip]');
    
    tooltipElements.forEach(element => {
      element.addEventListener('mouseenter', (e) => {
        this.showTooltip(e.target);
      });
      
      element.addEventListener('mouseleave', (e) => {
        this.hideTooltip(e.target);
      });
      
      element.addEventListener('focus', (e) => {
        this.showTooltip(e.target);
      });
      
      element.addEventListener('blur', (e) => {
        this.hideTooltip(e.target);
      });
    });
  }

  showTooltip(element) {
    const tooltipText = element.getAttribute('data-tooltip');
    if (!tooltipText) return;

    // Remover tooltip existente
    this.hideTooltip(element);

    // Crear nuevo tooltip
    const tooltip = document.createElement('div');
    tooltip.className = 'tooltip';
    tooltip.textContent = tooltipText;
    tooltip.setAttribute('data-tooltip-for', element.dataset.tooltipId || 'temp');

    // Posicionar tooltip
    document.body.appendChild(tooltip);
    
    const rect = element.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();
    
    // Calcular posición
    let left = rect.left + (rect.width / 2) - (tooltipRect.width / 2);
    let top = rect.top - tooltipRect.height - 8;
    
    // Ajustar si se sale de la pantalla
    if (left < 10) {
      left = 10;
    } else if (left + tooltipRect.width > window.innerWidth - 10) {
      left = window.innerWidth - tooltipRect.width - 10;
    }
    
    if (top < 10) {
      // Si no hay espacio arriba, mostrar abajo
      top = rect.bottom + 8;
      tooltip.classList.add('tooltip-bottom');
    }

    tooltip.style.left = left + 'px';
    tooltip.style.top = top + 'px';
    tooltip.style.position = 'fixed';

    // Mostrar tooltip con animación
    setTimeout(() => {
      tooltip.classList.add('show');
    }, 10);

    // Guardar referencia
    element._tooltip = tooltip;
  }

  hideTooltip(element) {
    if (element._tooltip) {
      element._tooltip.classList.remove('show');
      setTimeout(() => {
        if (element._tooltip && element._tooltip.parentNode) {
          element._tooltip.parentNode.removeChild(element._tooltip);
        }
        element._tooltip = null;
      }, 300);
    }
  }

  removeAllTooltips() {
    const tooltips = document.querySelectorAll('.tooltip');
    tooltips.forEach(tooltip => {
      if (tooltip.parentNode) {
        tooltip.parentNode.removeChild(tooltip);
      }
    });
    
    // Limpiar referencias
    const elements = document.querySelectorAll('[data-tooltip]');
    elements.forEach(element => {
      element._tooltip = null;
    });
  }
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  new BreadcrumbTooltips();
});

// Para compatibilidad con Turbo/Turbolinks
document.addEventListener('turbo:load', () => {
  new BreadcrumbTooltips();
});

// Para aplicaciones que usan eventos de navegación personalizados
document.addEventListener('turbolinks:load', () => {
  new BreadcrumbTooltips();
});

// Exportar para uso en otros scripts si es necesario
if (typeof module !== 'undefined' && module.exports) {
  module.exports = BreadcrumbTooltips;
}